import { render, staticRenderFns } from "./Authenticate.vue?vue&type=template&id=980bf9ce&scoped=true&lang=pug&"
import script from "./Authenticate.vue?vue&type=script&lang=js&"
export * from "./Authenticate.vue?vue&type=script&lang=js&"
import style0 from "./Authenticate.vue?vue&type=style&index=0&id=980bf9ce&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "980bf9ce",
  null
  
)

export default component.exports